module.exports = __webpack_public_path__ + "img/TECNOLOGIA-BALENO-3.18bb8b71.jpg";